import { useSelector } from "react-redux";
import { useRouteMatch as useRouteMatchOrigin } from "react-router-dom";
import { LinkTo } from "../constants/linkTo";
import { DisplayType } from "../constants/displayType";
import { AppTester } from "supporting";
import { useBreakpoint } from "@brg/ui";
import { LayoutConst } from "core";
import { isServer } from "shared/constants/isServer";
import { useRouteMatchSsr } from "./useRouteMatchSsr";
const useRouteMatch = isServer ? useRouteMatchSsr : useRouteMatchOrigin

const useIsDoubleGrid = ():boolean => {
  const gridType = useSelector((state: any) => state?.vt?.gridType);
  const isDesignerPage = useRouteMatch(LinkTo.designer);
  const isMedia = AppTester.isMediiia();
  const isMobile = useBreakpoint(LayoutConst.screen.s - 1);

  if (isMedia && isMobile) {
    return true;
  }

  return !isDesignerPage || gridType === DisplayType.doublegrid;
};

export default useIsDoubleGrid;
import { useSelector } from "react-redux";
import { useRouteMatch as useRouteMatchOrigin } from "react-router-dom";
import { LinkTo } from "../constants/linkTo";
import { DisplayType } from "../constants/displayType";
import { AppTester } from "supporting";
import { useBreakpoint } from "@brg/ui";
import { LayoutConst } from "core";
import { isServer } from "shared/constants/isServer";
import { useRouteMatchSsr } from "./useRouteMatchSsr";
const useRouteMatch = isServer ? useRouteMatchSsr : useRouteMatchOrigin

const useIsDoubleGrid = ():boolean => {
  const gridType = useSelector((state: any) => state?.vt?.gridType);
  const isDesignerPage = useRouteMatch(LinkTo.designer);
  const isMedia = AppTester.isMediiia();
  const isMobile = useBreakpoint(LayoutConst.screen.s - 1);

  if (isMedia && isMobile) {
    return true;
  }

  return !isDesignerPage || gridType === DisplayType.doublegrid;
};

export default useIsDoubleGrid;
